import { ArrowLeftOutlined, InboxOutlined } from "@ant-design/icons";
import {
	Typography,
	Form,
	Spin,
	Space,
	Col,
	Row,
	Upload,
	Button,
	InputNumber,
} from "antd";
import { Link } from "react-router-dom";
import { TextInput } from "@/components/atoms";
import { ROUTES } from "@/consts";
import useVoucherForm from "./useVoucherForm";

const { Title, Text } = Typography;

const VoucherForm = () => {
	const {
		loading,
		voucherId,
		normFile,
		beforeUpload,
		voucherForm,
		initialValues,
		onCreateEditVoucher,
		creatingVoucher,
		updatingVoucher,
		fetchTiersLoading,
		allTiersData,
		imageUrl,
		onRemoveImage,
		setSubmitStatus,
	} = useVoucherForm();
	return (
		<Spin spinning={loading}>
			<Space direction="vertical" style={{ width: "100%" }}>
				<Row>
					<Link to={ROUTES.Vouchers} relative="path" color="black">
						<Text>
							<ArrowLeftOutlined /> Back to all Vouchers
						</Text>
					</Link>
				</Row>
				<Row>
					<Title level={3}>{voucherId ? "Edit" : "Add"} a Voucher</Title>
				</Row>
				<Row>
					<Col span={24}>
						<Form
							layout="vertical"
							form={voucherForm}
							initialValues={initialValues}
							onFinish={onCreateEditVoucher}
						>
							<TextInput
								name="name"
								label="Voucher "
								rules={[
									{ required: true, message: "Please input a valid name!" },
								]}
								placeholder="اشتراك لمدة شهر لواتش ات"
								type="text"
							/>
							<Row gutter={20}>
								<Col span={12}>
									{imageUrl ? (
										<Upload
											listType="picture"
											onRemove={onRemoveImage}
											defaultFileList={
												imageUrl
													? [
															{
																uid: "-1",
																name: imageUrl,
																status: "done",
																url: imageUrl,
															},
													  ]
													: []
											}
										/>
									) : (
										<Form.Item label="Logo" required>
											<Form.Item
												label="Logo"
												// for some reason, this should be named "dragger" instead of "image"
												name="image"
												valuePropName="file"
												getValueFromEvent={normFile}
												noStyle
												rules={[
													{ required: true, message: "Please upload file!" },
												]}
											>
												<Upload.Dragger
													accept="image/*"
													multiple={false}
													maxCount={1}
													beforeUpload={beforeUpload}
												>
													<p className="ant-upload-drag-icon">
														<InboxOutlined />
													</p>
													<p className="ant-upload-text">
														Click or drag file to this area to upload
													</p>
													<p className="ant-upload-hint">
														Upload one file less than 1MB
													</p>
												</Upload.Dragger>
											</Form.Item>
										</Form.Item>
									)}
								</Col>
							</Row>
							<Row justify="space-between" gutter={20}>
								<Col span={12}>
									<TextInput
										name="tier_id"
										label="Tiers"
										placeholder="Search for tier"
										options={allTiersData?.getTiers}
										type="select"
										loading={fetchTiersLoading}
										rules={[
											{ required: true, message: "Please input a valid name!" },
										]}
									/>
								</Col>
							</Row>
							<Row />
							<Row>
								<Title level={3}>Gift Redemption </Title>
							</Row>
							<Row justify="start">
								<Col span={12}>
									<Form.Item
										label="Voucher Codes"
										required
										rules={[
											{ required: !voucherId, message: "Please upload file!" },
										]}
									>
										<Form.Item
											name="file"
											valuePropName="file"
											getValueFromEvent={normFile}
											noStyle
											rules={[
												{
													required: !voucherId,
													message: "Please upload file!",
												},
											]}
										>
											<Upload.Dragger
												accept=".xlsx"
												name="file"
												multiple={false}
												maxCount={1}
												beforeUpload={() => false}
											>
												<p className="ant-upload-drag-icon" />
												<p className="ant-upload-text">
													Click or drag file to this area to upload
												</p>
												<p className="ant-upload-hint">
													Upload one file less than 25MB
												</p>
											</Upload.Dragger>
										</Form.Item>
									</Form.Item>
								</Col>
							</Row>

							<Row>
								<Col span={12}>
									<Form.Item
										name="coins"
										label="Gift Price"
										rules={[
											{
												required: true,
												message: "Please input a valid price!",
											},
											{
												type: "number",
												min: 0,
												message: "price must be at least 0",
											},
										]}
									>
										<InputNumber
											placeholder="Enter Coins"
											type="number"
											style={{ width: "100%" }}
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row justify="space-between">
								<Col>
									<Form.Item>
										<Button type="ghost" htmlType="submit">
											<Text underline>
												<Link to={ROUTES.Vouchers}>Cancel</Link>
											</Text>
										</Button>
									</Form.Item>
								</Col>
								<Col>
									<Row>
										<Form.Item>
											<Button
												type="primary"
												htmlType="submit"
												onClick={() => setSubmitStatus(true)}
												loading={creatingVoucher || updatingVoucher}
											>
												Save and Publish
											</Button>
										</Form.Item>

										<Form.Item>
											<Button
												type="ghost"
												htmlType="submit"
												onClick={() => setSubmitStatus(false)}
												loading={creatingVoucher || updatingVoucher}
											>
												<Text underline>Draft</Text>
											</Button>
										</Form.Item>
									</Row>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Space>
		</Spin>
	);
};

export default VoucherForm;
